import React from "react";
import styled from "styled-components";
import { WealthyEnv } from "helpers";
import { colors } from "nxtconstants";

const CreateBrand = ({ brandData = {} }) => {
  return (
    <Section>
      <Container>
        <ContentWrapper>

          <TextContent>
            <MainHeading>
              {brandData.heading}
            </MainHeading>
            <Description>
              {brandData.description}
            </Description>
          </TextContent>

          <VisualContent>
            <CardImage
              src={brandData.image}
              alt="Digital onboarding card"
              width={560}
              height={560}
              loading="lazy"
            />
          </VisualContent>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  width: 85%;
  max-width: 125rem;
  background: #ECE9F4;
  margin: 10rem auto;
  border-radius: 3.2rem;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 85%;
    max-width: 125rem;
    margin: 5rem auto;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  position: relative;

  @media (max-width: 768px) {
    min-height:60rem;
  }
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  margin: 5rem 0 0 5rem;
  align-items: center;
  min-height: 50rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin: 0 2rem 2rem 2rem;
    text-align: center;
    min-height: auto;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.white};

  @media (max-width: 768px) {
    margin-left: 0;
    order: 2;
  }
`;

const BrandHeading = styled.h3`
  font-family: "Lato";
  font-size: 3rem;
  font-weight: 400;
  color: ${colors.black};
  margin-bottom: 6rem;

  @media (max-width: 768px) {
    font-size: 1.6rem;
    margin-bottom: 1.4rem;
    font-weight:600;
  }
`;

const MainHeading = styled.h2`
  font-family: "DM Serif Display";
  font-size: 5rem;
  font-weight: 400;
  color: ${colors.black};
  margin-bottom: 4rem;
  line-height: 6rem;

  @media (max-width: 768px) {
    font-size: 2.7rem;
    line-height: 3rem;
    margin-bottom: 1.4rem;
  }
`;

const Description = styled.p`
  font-family: "Lato";
  font-size: 2rem;
  color: ${colors.black};
  line-height: 1.6;
  margin: 0;
  max-width: 50rem;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    line-height: 1.5;
    max-width: unset;
    margin: auto;
    width: 31rem;
    height: 9rem;
  }
`;

const VisualContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 50rem;

  @media (max-width: 768px) {
    height: 32rem;
    width: 32rem;
    margin: auto;
    order: 1;
    margin-bottom: 1rem;
  }
`;

const CardImage = styled.img`
  width: 65rem;
  height: auto;
  border-radius: 2rem;

  @media (max-width: 768px) {
    object-fit: cover;
    width: 100%;
    border-radius: 1.2rem;
  }
`;
export default CreateBrand;